import { getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails } from 'src/client/spendesk-api';

export type GetInvoiceCardDetailsInput = {
  companyId: string;
  payableId: string;
};

export type InvoiceCardDetails = {
  requestId?: string;
  hasCardAccess?: boolean;
  invoiceStatus?: string;
};

export async function getInvoiceCardDetails(
  input: GetInvoiceCardDetailsInput,
): Promise<InvoiceCardDetails | undefined> {
  const { payableId, companyId } = input;

  const response = await getV2ApiCompanyIdCardsInvoicesPayableIdInvoiceDetails({
    path: {
      companyId,
      payableId,
    },
  });

  if (response.statusCode !== 200) {
    throw new Error('Failed to retrieve invoice card details');
  }

  return response.body.data;
}
